








































import axios from 'axios';
import CoResourcePreview from '../../Organisms/co-resource-preview/CoResourcePreview.vue';
import CoCard from '../co-card/CoCard.vue';
import CoHeadline from '../../Atoms/co-headline/CoHeadline.vue';
import CoPrice from '../../Atoms/co-price/coPrice.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';

interface Price {
    PriceInCents: number;
    Currency: string;
    TaxRate: number;
    TaxName: string;
    Inclusive: boolean;
    Unit?: string;
}

export default {
    name: 'CoCardResource',
    components: {
        CoResourcePreview,
        CoCard,
        CoHeadline,
        CoPrice,
        CoIcon,
    },
    props: {
        plan: {
            type: Object,
            required: false,
        },
        resource: {
            type: Object,
            required: true,
        },
        withDelete: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            imageURL: this.resource.ImageURL,
            name: '',
            windowWidth: window.innerWidth,
            Price: 0,
            bookingCredits: null,
            currency: '',
            resourcePrice: '',
            availability: false,
            details: true,
            resourceObject: {},
        };
    },
    created() {
        this.resourceObject = this.resource;
    },

    methods: {
        deleteResource() {
            this.$emit('deleteResource', this.resource);
        },
        priceObject() {
            const priceObj: Price = {
                PriceInCents: this.resource.PriceInCentsPerHour,
                Currency: this.resource.Currency,
                Unit: 'hour',
                TaxName: '',
                TaxRate: 0,
                Inclusive: false,
            };

            if (this.resource.TaxRate) {
                priceObj.TaxRate = this.resource.TaxRate.Percentage;
                priceObj.TaxName = this.resource.TaxRate.Name;
                priceObj.Inclusive = this.resource.TaxRate.Inclusive;
            }
            return priceObj;
        },
        select(event) {
            // if event is not target child of CoResourcePreview component than stop
            if (event && event.target.closest('.CoResourcePreview')) {
                return;
            }
            const r = JSON.parse(JSON.stringify(this.resource));
            this.$emit('select', r);
        },

        resourceDetails(event) {
            event.preventDefault();

            this.$bvModal.show(`viewResourceModal-${this.resource.ID}`);
        },
    },
};
